<template>
    <section-text class="loading-section" v-if="isShown">
        <template v-slot:custom>
            <loading-spinner v-if="isLoading"></loading-spinner>
            <alert-error :alert="error" v-if="isError"></alert-error>
        </template>
    </section-text>
</template>

<script>
export default {
    name: 'LoadingSection',
    props: ['loading', 'error'],
    computed: {
        isShown() {
            return this.isLoading || this.isError;
        },
        isLoading() {
            return this.loading && !this.error;
        },
        isError() {
            return !!this.error;
        },
    },
};
</script>
